import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledProofsSectionComponent } from "./proofs-section-component.scss.js";

export default function ProofsSectionComponent(props) {
  const { proofs, backgroundImage } = props;

  return (
    <StyledProofsSectionComponent backgroundImage={backgroundImage}>
      <div className="proofs-container">
        {proofs?.map((proof, index) => {
          return (
            <div className="proof" key={index}>
              <FullParagraph {...proof} />
            </div>
          );
        })}
      </div>
    </StyledProofsSectionComponent>
  );
}
